import React, { useState, useContext, useRef } from "react";
import moment from "moment/moment";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import { useReactToPrint } from "react-to-print";
import { Loanbackprint } from "./loanbackprint";

const Customer_loan_back_ledger_table = ({loan_in}) => {
    const [dollar_price, setdollar_price] = useState();
    const [loan_in_id, setloan_in_id] = useState();
    const [loan_in_date, setloan_in_date] = useState();
    const [amount, setamount] = useState();
    const [note, setnote] = useState();
    const [customer_id, setcustomer_id] = useState();
    const [customer_name, setcustomer_name] = useState();
    const [customer_address, setcustomer_address] = useState();
    const [customer_phone, setcustomer_phone] = useState();
    const [customer_loan, setcustomer_loan] = useState();

    const printRef = useRef();
        
    const printFn = useReactToPrint({
        contentRef: printRef,
        documentTitle: "loanback",
        preserveAfterPrint: true,
        print: (printIframe) =>
        new Promise(() => {
            printIframe.style.display = "none";
            printIframe.contentWindow?.print();
        }),
    });
    return (
        <div>
            <div
                style={{
                position: 'absolute',
                left: '-99999px',
                top: 0
                }}
            >
                <Loanbackprint ref={printRef} dollar_price={dollar_price} loan_in_id={loan_in_id} loan_in_date={loan_in_date} amount={amount} note={note} customer_id={customer_id} customer_name={customer_name} customer_address={customer_address} customer_phone={customer_phone} customer_loan={customer_loan} sub_state="ok" />
            </div>
            {/* Expense List Card */}
                <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto"> 
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">لیستی قەرزی گەڕاوەی کڕیار</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ناوی کڕیار
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بەرواری گەڕاندنەوە
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بڕی گەڕاوە
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                نرخی دۆلار
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                تێبینی
                            </th>
                            {/* <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                گۆڕانکاری
                            </th> */}
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                پرینت
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {loan_in?.map((lis)=>(
                        <tr key={lis.loan_in_id} className="hover:bg-slate-50 transition-colors duration-100">
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis.customer_name}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {moment(lis.loan_in_date).format("YYYY-MM-DD hh:mm a")}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {numberbeautify(money_rounding(lis.loan_in_amount))} $
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {numberbeautify(money_rounding(lis.loan_in_dollar_price))}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis?.loan_in_note}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                <button
                                    className="bg-slate-600 text-white active:bg-slate-800 font-bold uppercase text-sm px-3 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button"
                                    onClick={() => {
                                        setdollar_price(lis.loan_in_dollar_price);
                                        setloan_in_id(lis.loan_in_id);
                                        setloan_in_date(lis.loan_in_date);
                                        setamount(lis.loan_in_amount);
                                        setnote(lis.loan_in_note);
                                        setcustomer_id(lis.customer_id);
                                        setcustomer_name(lis.customer_name);
                                        setcustomer_address(lis.customer_address);
                                        setcustomer_phone(lis.customer_phone);
                                        setcustomer_loan(lis.customer_loan);
                                        setTimeout(() => {
                                            printFn();
                                        }, 500);
                                    }}
                                >
                                    پرینت
                                </button>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Customer_loan_back_ledger_table